import React from 'react'
import styled from 'styled-components'
import Text, { useTranslations } from '../../utils/Text'
import media from '../../utils/media'
import Image from './Image'
import BodyText from './BodyText'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 350px;
  margin: auto 15px 80px;
  &:nth-child(odd) {
    flex-direction: row-reverse;
    .img-skin-wrapper {
      justify-content: flex-end;
    }
  }
  @media (max-width: 991px) and (min-width: 768px) {
    height: 380px;
  }
  ${media.laptopM`
    margin: auto auto 80px;
  `}
  ${media.laptop`
    margin-bottom: 40px;
    height: 100%;
  `}
  ${media.tablet`
    flex-direction: column;
    height: auto;
    margin-right: 0;
    &:nth-child(odd) {
      flex-direction: column;
      height: auto;
      .img-skin-wrapper {
        justify-content: center;
      }
    }
    & > div:first-child {
      margin-bottom: 20px;
    }
  `}
`

const ImgWrapper = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  ${media.laptopM`
    padding: 0 10px;
  `}
  ${media.tablet`
    justify-content: center;
    padding: 0 0;
    width: 100%;
  `}
`

const TxtWrapper = styled.div`
  width: 50%;
  height: 350px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 6%;
  ${media.laptop`
    height: 100%;
    padding: 0 20px;
  `}
  ${media.tablet`
    padding: 0 0;
    height: 100%;
    width: 100%;
    text-align: center;
  `}
`

const Title = styled.div`
  margin-bottom: 29px;
  span {
    display: block !important;
  }
  p {
    font-size: 32px;
    line-height: 1.23;
    font-family: ${props =>
      props.titleFamily ? props.titleFamily : 'Raleway'};
    em {
      font-style: normal;
      color: ${props => props.accent};
    }
  }
  ${media.tablet`
    margin-bottom: 20px;
    p {
      font-size: 26px;
    }
  `}
`

export default function ImageText({
  src,
  alt,
  maxWidth,
  minWidth,
  accent,
  title,
  titleTwo,
  marginBText,
  text,
  textTwo,
  fontFamily,
  titleFamily,
}) {
  const srcToShow = useTranslations(src, {})
  return (
    <Container>
      <ImgWrapper className="img-skin-wrapper">
        <Image
          src={srcToShow}
          alt={alt}
          maxWidth={maxWidth}
          minWidth={minWidth}
        />
      </ImgWrapper>
      <TxtWrapper>
        <Title accent={accent} titleFamily={titleFamily}>
          <Text id={title} markdown />
          <Text id={titleTwo} markdown />
        </Title>
        <BodyText
          text={text}
          marginBText={marginBText}
          fontFamily={fontFamily}
        />
        {textTwo && (
          <BodyText
            text={textTwo}
            marginBText={marginBText}
            fontFamily={fontFamily}
            className="text-child"
          />
        )}
      </TxtWrapper>
    </Container>
  )
}
